import {
  FilterType,
  buildExpensableGroupsDataTableFilter,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'

const reportDateFilter = ({ source }: BaseFilterProps) =>
  buildExpensableGroupsDataTableFilter(source, {
    type: FilterType.Date,
    categories: [
      {
        kind: 'DateTimePicker',
        operation: 'between',
      },
    ],
    identifier: 'expensesList.reportDateFilter',
    path: 'reviewRequestAt',
    title: i18n.t('expenses_v2.list.header.review_request_at'),
  })

export default reportDateFilter
